// olap-client/src/components/chat/ProfileTab.jsx
import React from 'react';

const ProfileTab = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  return (
    <div style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      background: '#ffffff'
    }}>
      <div style={{
        padding: '16px',
        borderBottom: '1px solid #e4e4e5',
        fontWeight: 'bold',
        fontSize: '18px'
      }}>
        Профиль
      </div>
      <div style={{
        padding: '20px',
        textAlign: 'center',
        borderBottom: '1px solid #e4e4e5'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          background: '#3390ec',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '32px',
          margin: '0 auto 12px'
        }}>
          👤
        </div>
        <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
          {user.persons_info?.name || 'Пользователь'} {user.persons_info?.surname || ''}
        </div>
        <div style={{ fontSize: '13px', color: '#707579', marginTop: '4px' }}>
          {user.email || 'email@example.com'}
        </div>
      </div>
      <div style={{ flex: 1, overflowY: 'auto' }}>
        <div style={{
          padding: '14px 16px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <span style={{ fontSize: '20px' }}>📱</span>
          <div>
            <div style={{ fontSize: '15px' }}>Телефон</div>
            <div style={{ fontSize: '13px', color: '#707579' }}>
              {user.persons_info?.phone || 'Не указан'}
            </div>
          </div>
        </div>
        <div style={{
          padding: '14px 16px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <span style={{ fontSize: '20px' }}>@</span>
          <div>
            <div style={{ fontSize: '15px' }}>Имя пользователя</div>
            <div style={{ fontSize: '13px', color: '#707579' }}>
              Не задано
            </div>
          </div>
        </div>
        <div style={{
          padding: '14px 16px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <span style={{ fontSize: '20px' }}>ℹ️</span>
          <div>
            <div style={{ fontSize: '15px' }}>О себе</div>
            <div style={{ fontSize: '13px', color: '#707579' }}>
              Не указано
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileTab;